import type {PublishedProductCatalogSnapshot} from '../../../packages/catalog/product-catalog.ts';
import type {createBusinessRuntime} from '../../../packages/runtime/business-runtime.ts';

type BusinessRuntime = ReturnType<typeof createBusinessRuntime>;

export interface SmmRuntimeHost {
  readonly runtime: BusinessRuntime;
  readonly catalog: PublishedProductCatalogSnapshot;
  readonly businessDate: () => string;
  readonly operatorId: string;
  readonly deviceId: string;
  readonly sessionRef?: string;
}

type SmmGlobal = typeof globalThis & {
  __MOREFUNOS_SMM_RUNTIME__?: SmmRuntimeHost;
};

const text = (value: string | undefined): string | null => {
  const normalized = value?.trim();
  return normalized ? normalized : null;
};

export function resolveSmmRuntimeHost(): SmmRuntimeHost | null {
  const candidate = (globalThis as SmmGlobal).__MOREFUNOS_SMM_RUNTIME__;
  if (!candidate?.runtime || !candidate.catalog || typeof candidate.businessDate !== 'function') return null;
  const operatorId = text(candidate.operatorId);
  const deviceId = text(candidate.deviceId);
  if (!operatorId || !deviceId) return null;
  const sessionRef = text(candidate.sessionRef);
  return {
    runtime: candidate.runtime,
    catalog: candidate.catalog,
    businessDate: candidate.businessDate,
    operatorId,
    deviceId,
    ...(sessionRef ? {sessionRef} : {}),
  };
}
